// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"61796688","213":"b78dec01","239":"551f2cea","415":"8b61ce31","455":"6de7f7b0","526":"22af0a7b","759":"fdc96752","906":"e44e8c15","979":"ea36eb75"}[chunkId] + ".chunk.js";
};